import { c as _c } from "react/compiler-runtime";
import type { Ref } from 'react';
import { useCreditCardCompareOfferContext } from '../../OfferContext';
import { ProductCardApplyNow } from '../components/ApplyNow';
import { ProductCardCardAndTitle } from '../components/CardAndTitle';
import { Observer } from '../components/Observer';
import { ProductCardRating } from '../components/Rating';
import { ProductCardObserverContainer } from './ProductCardObserver.container';
type ProductCardProps = {
  innerRef: Ref<HTMLDivElement>;
};
export function ProductCard(t0) {
  const $ = _c(14);
  const {
    innerRef
  } = t0;
  const {
    analytics
  } = useCreditCardCompareOfferContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Observer><ProductCardCardAndTitle /></Observer>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== innerRef) {
    t2 = <ProductCardObserverContainer innerRef={innerRef}>{t1}</ProductCardObserverContainer>;
    $[1] = innerRef;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ProductCardRating />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== analytics.section) {
    t4 = {
      ...analytics.section,
      name: "cc_compare_grid"
    };
    $[4] = analytics.section;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== analytics.marketplacePayload) {
    t5 = {
      ...analytics.marketplacePayload,
      section_name: "cc_compare_grid"
    };
    $[6] = analytics.marketplacePayload;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <ProductCardApplyNow needsFixedHeight={true} analyticsProps={{
      section: t4,
      marketplacePayload: t5
    }} />;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t6) {
    t7 = <>{t2}{t3}{t6}</>;
    $[11] = t2;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}